import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AIPoweredEcommerceSolutionsInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="AI-Powered E-commerce Solutions in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Smart Commerce</Subheading>}
        heading={
          <Heading>
            AI-Powered <span tw="text-primary-500">E-commerce Solutions</span>{" "}
            in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we deliver AI-powered e-commerce solutions in
            **Dubai**, leveraging artificial intelligence to enhance
            personalization, optimize operations, and boost sales. Transform
            your online store with cutting-edge technology.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI technology visualization
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Modern tech workspace
          "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce with digital elements
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Power Up Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="AI-Driven E-commerce Excellence in Dubai"
        description="We integrate AI to revolutionize your online store."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Personalized Shopping",
            description: "AI tailors experiences to each customer.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Smart Automation",
            description: "Streamline inventory and pricing with AI.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Predictive Analytics",
            description: "Forecast trends and optimize sales.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure AI Integration",
            description: "Safe and reliable AI enhancements.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Cross-Device Compatibility",
            description: "AI works seamlessly on all platforms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Innovators",
            description: "Dubai’s leader in AI e-commerce solutions.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our AI-Powered Development Process"
        description={
          <Description>
            We build intelligent e-commerce stores with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Identify your AI needs and goals.</li>
              <li>Design: Create a smart, user-friendly interface.</li>
              <li>
                Development: Integrate AI for personalization and automation.
              </li>
              <li>Testing: Ensure AI features perform flawlessly.</li>
              <li>Launch: Deploy a future-ready online store.</li>
              <li>Support: Optimize and update AI capabilities.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI data visualization
          "https://images.unsplash.com/photo-1594979194853-f7dcd77a0a1b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team working on AI solutions
          "https://images.unsplash.com/photo-1550439062-609e1531270e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Digital analytics dashboard
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="AI-Powered Success in Dubai"
        description="Our solutions drive measurable impact."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Growth",
            description: "AI personalization boosted revenue by 180%.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Efficiency Gains",
            description: "Automation cut operational time by 30%.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "97% approval for AI-driven stores.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for AI Innovation?</Subheading>}
        heading="AI-Powered E-commerce Solutions in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for AI-powered e-commerce solutions in
            Dubai. Elevate your online store with intelligent technology—contact
            us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1577043710482-1b3c7a7e5128?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai skyline with tech overlay
          "https://images.unsplash.com/photo-1556740764-0434cfcb1e41?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce payment technology
          "https://images.unsplash.com/photo-1536148935331-408321065b18?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // AI connection visualization
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
